import { ScoringDefinitionInterface, ScoringRuleInterface } from '@vendasta/crm';
import { UnaryOperators } from './constants';
import { ObjectType } from '@galaxy/crm/static';
import {
  EmptyScoringDefinitionsError,
  EmptyScoringRulesError,
  InvalidContributionError,
  MissingFieldError,
  MissingOperatorError,
  MissingValueError,
} from './errors';
import { ScoringDefinitionValidationOpts } from './interfaces';

export function validateScoringDefinitions(
  positiveScoringDefinitions: ScoringDefinitionInterface[],
  negativeScoringDefinitions: ScoringDefinitionInterface[],
): void {
  const allDefinitions = [...positiveScoringDefinitions, ...negativeScoringDefinitions];
  if (!allDefinitions.length) {
    throw new EmptyScoringDefinitionsError();
  }
  positiveScoringDefinitions.forEach((d) => validateScoringDefinition(d, { minContribution: 1 }));
  negativeScoringDefinitions.forEach((d) => validateScoringDefinition(d, { maxContribution: -1 }));
}

export function validateScoringDefinition(
  scoringDefinition: ScoringDefinitionInterface,
  validation?: ScoringDefinitionValidationOpts,
): void {
  if (!scoringDefinition.contribution) {
    throw new InvalidContributionError();
  }
  if (validation?.minContribution !== undefined && scoringDefinition.contribution < validation.minContribution) {
    throw new InvalidContributionError();
  }
  if (validation?.maxContribution !== undefined && scoringDefinition.contribution > validation.maxContribution) {
    throw new InvalidContributionError();
  }
  if (!scoringDefinition.scoringRules?.length) {
    throw new EmptyScoringRulesError();
  }
  validateScoringRules(scoringDefinition.scoringRules);
}

export function validateScoringRules(scoringRules: ScoringRuleInterface[]): void {
  scoringRules.forEach((rule) => validateScoringRule(rule));
}

export function validateScoringRule(rule: ScoringRuleInterface): void {
  const filter = rule.objectRules?.[0]?.filter;
  if (!filter?.fieldId) {
    throw new MissingFieldError();
  }
  if (!filter?.operator) {
    throw new MissingOperatorError();
  }
  if (!UnaryOperators.includes(filter.operator) && !filter.values?.length) {
    throw new MissingValueError();
  }
}

export function isAcceptedObjectType(value: any): value is ObjectType {
  return value === 'Company' || value === 'Contact';
}
